import {
  CaptionText,
  H1,
  H3,
  H4,
  P1,
  P2,
  P3
} from '../../../styles/FontStyles';

import { Desktop, Mobile } from '../../../App';

import { Link } from 'react-router-dom';

import willyMemeBanner from '../../../assets/images/backoffice/willyImages/willyMemeBanner.png';
import willyMemeBannerMobile from '../../../assets/images/backoffice/willyImages/willyMemeBannerMobile.png';
import willyMemeBannerZero from '../../../assets/images/backoffice/willyImages/willyMemeZeroBanner.png';
import willyMemeBannerZeroMobile from '../../../assets/images/backoffice/willyImages/willyMemeZeroBannerMobile.png';

import { MY_HUBS } from '../../../routes/routes';

import { useAppSelector } from '../../../app/hooks';
import { Flexed } from '../../../styles/GlobalComponents';
import { lightTheme } from '../../../styles/GlobalStyles';
import { formatUSD } from '../../../helpers/helperFunctions';

export const WillyMemeCoinsBanner = () => {
  const { totalCoins, daysLeft } = useAppSelector(
    (state) => state.dashboard.willyCoins
  );

  return (
    <>
      <Link to={MY_HUBS}>
        <Desktop
          style={{
            position: 'relative',
            borderRadius: 12,
            marginBottom: 40
          }}>
          <Flexed
            m='40px 0 40px 50px'
            mSM='0'
            mbSM='20'
            column
            width='50%'
            widthSM='100%'
            style={{ position: 'absolute', left: 0, top: 0 }}>
            <P1
              semiBold
              style={{ fontSize: 26, lineHeight: '100%' }}
              color={'#fff'}>
              You Have
            </P1>

            <H1 style={{ fontSize: 96, lineHeight: '106px', color: '#0034e2' }}>
              {formatUSD(totalCoins)}
            </H1>

            <H3 caps mb='5' style={{ color: '#0034e2' }}>
              Willy Meme Coins
            </H3>

            <H3
              mb='16'
              style={{
                color: lightTheme.colors.neutral50,
                textTransform: 'uppercase'
              }}>
              Willy Meme Coins are in the works
              <br /> exciting updates coming soon!
            </H3>

            <Desktop>
              <P1 color={lightTheme.colors.neutral50}>
                *You need to have a paid Back-office subscription.
              </P1>
            </Desktop>
          </Flexed>

          <img
            src={willyMemeBanner}
            alt='willyMemeBannerZeroMobile'
            style={{ width: '100%' }}
          />
        </Desktop>
        <Mobile
          style={{
            position: 'relative',
            borderRadius: 12,
            marginBottom: 40
          }}>
          <Flexed
            m='20px'
            mbSM='20'
            column
            width='50%'
            widthSM='100%'
            style={{ position: 'absolute', left: 0, right: 0, top: 0 }}>
            <H3 semiBold color={lightTheme.colors.neutral50}>
              You Have
            </H3>

            <H1 style={{ lineHeight: '69px', color: '#0034e2' }}>
              {formatUSD(totalCoins)}
            </H1>

            <H4 caps mb='2' style={{ color: '#0034e2' }}>
              Willy Meme Coins
            </H4>

            <P3
              mb='16'
              style={{
                color: lightTheme.colors.neutral50,
                textTransform: 'uppercase'
              }}>
              Willy Meme Coins are in
              <br /> the works exciting
              <br /> updates coming soon!
            </P3>
          </Flexed>

          <CaptionText
            center
            style={{ position: 'absolute', bottom: 50, width: '100%' }}
            color={lightTheme.colors.blue}>
            *You need to have a paid Back-office subscription.
          </CaptionText>

          <img
            src={willyMemeBannerMobile}
            alt='willyMemeBannerZeroMobile'
            style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
          />
        </Mobile>
      </Link>
    </>
  );
};
